module.exports = __webpack_public_path__ + "img/folder-closed.52060d92.svg";